import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { LoginService, UserProfileService, ProductRouteInfoService } from '../core';
import { LoginModel } from '../core/models/login-model';
import { environment} from '../../environments/environment'
import { timeInRange } from '@progress/kendo-angular-dateinputs/dist/es2015/util';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: []
})
export class LoginComponent implements OnInit, OnDestroy {
  public loginModel: LoginModel = {username: "", password: ""};
  public errors: string[] = [];
  public stage1: boolean = true;
  customerSelectionList: Array<{name:string,id:number}> = [];
  public customerDropdownPopupSettings = {height: 200};
  rediretTo: any;
  subForDestroy:Subscription;
 @ViewChild("list", { static: true }) list;

  public selectedCustomer: {name:string,id:number}; //{ text: string, value: number };
  constructor(
    private loginService: LoginService,
    private userProfileService: UserProfileService,
    private router: Router,
    private productRouteInfoService: ProductRouteInfoService,
    private activatedRoute: ActivatedRoute
    ) {
  }

  ngOnInit() {
    
      this.rediretTo=null;
      this.subForDestroy = this.activatedRoute.queryParams.subscribe(p =>{
        this.rediretTo = p.redirectTo;
      });
      this.userProfileService.IsUserLoggedIn()
            .subscribe(yes =>{
              if(!yes ){
                if(environment.PortalLoginPage != ''){
                  window.location.href=environment.PortalLoginPage; 
                }
              }
      },err =>{console.log(err)});
  }
  ngOnDestroy(){
    this.subForDestroy.unsubscribe();
  }

  public login(event): void {
    this.errors = [];
    let f = this.loginService.login(this.loginModel)
      .subscribe((rtn) => {
        console.log(JSON.stringify(rtn));
        if(rtn!="good"){
          this.errors.push("Note: " + rtn + ", proceeding with your login request");
        }
        this.userProfileService
          .UpdateUserState()
          .subscribe(b => {
            this.userProfileService.SecurityGetUser()
              .subscribe(r => {
                this.selectedCustomer ={name:"",id:0};
                this.customerSelectionList = r.map(item => {
                  return {name: item.text, id: item.value};
                }).sort((a,b)=> a.name.toLocaleUpperCase().localeCompare(b.name.toLocaleUpperCase()));
                this.selectedCustomer = this.customerSelectionList[0];
                if (this.customerSelectionList.length === 1) {
                  this.customerConfirmed();//auto select the only customer
                }
                else{
                  this.stage1 = false;
                }
              },
              error => this.ShowError(error, "GetUser"))
          },
          error => this.ShowError(error, "IsUserLoggedIn"))
        //this.utilityService.navigate('');
      },
      (error: any) => this.ShowError(error, "login")
      );

  };


  logout() {
    this.errors = [];
    this.loginService.logout()

      .subscribe(sumn => {
        console.log(JSON.stringify(sumn));
        this.stage1 = true;
      },
      (error: any) => this.ShowError(error, "logout"),
      () => this.stage1 = true);
  }
  public userInfo() {
    this.errors = [];
    this.loginService.userInfo()
      .subscribe(sumn => {
        console.log(JSON.stringify(sumn));

      },
      (error: any) => this.ShowError(error, "userInfo")
      );
  }

  public customerConfirmed() {
    let rr = this.selectedCustomer;
    let found = this.userProfileService.GetMappedCustomer(this.selectedCustomer.name);
    let custmerID: number = found.value;
    this.errors=[];
    this.loginService.updateSessionSetCustomer(custmerID)
      .subscribe(() => {
        d => console.log(JSON.stringify(d));
        let x = this.userProfileService
          .UpdateUserState()
          .subscribe(b => {
            if(this.rediretTo!=null && this.rediretTo.length>0){

              const productsMappping = this.productRouteInfoService.Get(this.userProfileService.data.ProductAccess);
              if(!productsMappping.some( pm => this.rediretTo.includes( pm.mainPath)))
                this.rediretTo = "";
            }
            if(this.rediretTo!=null && this.rediretTo.length>0){
              this.router.navigateByUrl(this.rediretTo);
            }
            else{
              var nxt = this.productRouteInfoService.GetHighestPriorityProduct( this.userProfileService.data.ProductAccess);
              if(nxt){
                this.productRouteInfoService.NavigateToHighestPriorityProduct(this.userProfileService.data.ProductAccess,this.router);
              }
              else{
                this.errors.push("None of the Rate Integrity products has been activated, contact customer support ");
              }
            }

          }
          , error => this.ShowError(error, "IsUserLoggedIn")
          );
      },
      (errors: any) => this.ShowError(errors, "SetCustomer")
      );
  }

  ShowError(error: any, callInfo: string) {
    console.log(JSON.stringify(error));
    if(typeof error._body === 'string' && error._body.length>1){
      let e = error.json();
      if (e && e.message) {
        this.errors.push(e.message);
        if ('modelState' in e) {
          let props = Object.keys(e.modelState);
          props.forEach((key, ndx) => {
            e.modelState[key].forEach(element => {
              this.errors.push(element);
            });
          });
        }
        return;
      }
    }
    if(typeof error.statusText === 'string' && error._body.length>1){
      this.errors.push("Request failed, " + callInfo + " status code " + error.status);
      return;
    }
    this.errors.push("Request failed, " + callInfo);
  }
  OnCustomerChanged(value:any){
    if(value)
      this.selectedCustomer = value;
  }
}
